const es = {
  10000001: 'Celebración del Segundo Aniversario de SuperEx',
  10000002: '¡Inicia sesión para obtener grandes recompensas!',
  10000003: 'Según el número de participantes, cuanto mayor sea el número de participantes, mayor será el premio, hasta 10 000 USDT',
  10000004: 'Celebración del aniversario de SuperEx2',
  10000005: 'Gana 20 000 USDT en la competencia de comercio de futuros',
  10000006: `Competencia de clasificación de volumen de negociación: Desbloquee el premio más alto del fondo de bonos de <span style="color: #ffc72b;">10,000</span> USDT`,
  10000007: 'Campeonato Futures',
  10000008: 'Gana 20 000 USDT en la competencia de comercio de futuros ',
}
export default  es



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/es.js